import { withWebAssetsTheme } from '../../theme';
import { withClientErrorPage } from '../ClientError';

import FiveHundredError from './FiveHundredError';

const FiveHundredErrorPage = () =>
  withWebAssetsTheme(withClientErrorPage(FiveHundredError))({});

export default FiveHundredErrorPage;
